import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/efs/PageHeader';
import { useCurrentUser } from '@/lib/auth-context';
import { homeRouteFor } from '@/lib/role-access';

export const ForbiddenPage = () => {
  const { t } = useTranslation();
  const user = useCurrentUser();
  return (
    <div className="space-y-6">
      <PageHeader
        title={t('efs.common.errors.forbidden_title', {
          defaultValue: '403 — 沒有權限',
        })}
      />
      <div className="efs-panel p-6 text-sm text-efs-text-muted">
        <p>
          {t('efs.common.errors.forbidden_body', {
            defaultValue: '您目前的角色無法存取這個頁面。如果您認為這是錯誤，請聯絡管理員。',
          })}
        </p>
        <Button asChild variant="outline" className="mt-4">
          <Link to={homeRouteFor(user)}>
            {t('efs.common.errors.back_home', { defaultValue: '返回首頁' })}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default ForbiddenPage;
